import { render, staticRenderFns } from "./AdminRoomMenu.vue?vue&type=template&id=08148b18&scoped=true&"
import script from "./AdminRoomMenu.vue?vue&type=script&lang=js&"
export * from "./AdminRoomMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoomMenu.vue?vue&type=style&index=0&id=08148b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08148b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
